import type { ButtonProps } from '@chakra-ui/react';
import { AnchorButton } from 'components/ui/AnchorButton';

interface CtaButtonProps extends ButtonProps {
  anchorId: string;
  colorScheme?: 'white' | 'gray';
}

export function CtaButton({
  anchorId,
  size,
  colorScheme = 'gray',
  ...props
}: CtaButtonProps) {
  return (
    <AnchorButton
      anchorId={anchorId}
      size={size}
      colorScheme={colorScheme}
      minWidth="120px"
      {...props}
    />
  );
}
